import styled from "styled-components";

export const SOnboardingAssetFieldButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: auto;
  width: fit-content;
`;
